/**
 * Downloads a file via programmatic fetch and triggers a browser save dialog.
 *
 * This is necessary when the URL can't be used as a direct `<a href>` link —
 * e.g. when a dev-server redirect proxy would intercept browser navigations
 * but XHR/fetch requests pass through to the staging proxy correctly.
 */
export const downloadFile = async (url: string, filename: string) => {
  const response = await fetch(url, { credentials: 'include' })
  if (!response.ok) {
    throw new Error(`Download failed: ${response.status} ${response.statusText}`)
  }
  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
}
